export default __webpack_public_path__ + "static/media/mobileJourney.7a4986c4.png";